import {
  AutoStack,
  DayPickerStrings,
  FormikGraphQLDatePicker,
  onFormatDate,
} from 'components'
import { FieldArray, FieldProps } from 'formik'
import { FormikDropdown } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { Proving } from 'gql.generated'
import { DayOfWeek, IDropdownOption, Label } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { ParticipantListItem } from 'views/ParticipantViews'
import { useTrackHotelsQuery } from 'views/ProvingDetailsView/hooks'
import { ProvingDetailsTrackHotelValues } from '..'

export const ProvingDetailsTrackHotelReturnStatusForm: React.FC<{
  proving: Partial<Proving>
  participant?: Partial<ParticipantListItem>
}> = ({ proving, participant }) => {
  const { t } = useTranslation()

  const { data, loading } = useTrackHotelsQuery({
    variables: { provingGroundId: proving.provingGround!._id },
  })

  // const validateDateFrom = () => {
  //   if (participant) {
  //     return new Date(participant.provingDateFrom as any)
  //   } else {
  //     return new Date(proving.dateFrom)
  //   }
  // }

  // const validateDateTo = () => {
  //   if (participant) {
  //     return new Date(participant.provingDateTo as any)
  //   } else {
  //     return new Date(proving.dateTo)
  //   }
  // }

  const hotels: IDropdownOption[] =
    data && !loading
      ? data.resources.map((resource) => ({
          key: resource._id,
          text: resource.title,
        }))
      : []

  const statusOptions: IDropdownOption[] = [
    {
      key: 'notRequired',
      text: t('dropdown.option.trackHotels.status.notRequired'),
    },
    {
      key: 'open',
      text: t('dropdown.option.trackHotels.status.open'),
    },
    {
      key: 'workInProgress',
      text: t('dropdown.option.trackHotels.status.workInProgress'),
    },
    {
      key: 'finished',
      text: t('dropdown.option.trackHotels.status.finished'),
    },
  ]

  return (
    <FormStack>
      <Label>{t('field.trackHotel.return.header')}</Label>
      <FieldArray name="trackHotels.return">
        {({ form, name, ...helpers }) => {
          const values: {
            hotel: string
            dateFrom: Date
            dateTo: Date
          }[] = form.values.trackHotels.return

          return (
            <AutoStack tokens={{ childrenGap: 12 }}>
              {values.map((x: any, i: number) => (
                <FieldStack horizontal={true} key={i}>
                  <FieldStackItem
                    name={`trackHotels.return.${i}.hotel`}
                    render={(
                      fieldProps: FieldProps<ProvingDetailsTrackHotelValues>
                    ) => (
                      <FormikDropdown
                        label={t('field.trackHotel.return.label')}
                        {...fieldProps}
                        options={hotels}
                        disabled={true}
                        dropdownWidth={400}
                      />
                    )}
                  />
                  <FieldStackItem
                    name={`trackHotels.return.${i}.dateFrom`}
                    render={(fieldProps) => (
                      <FormikGraphQLDatePicker
                        label={t('field.trackHotel.dateFrom.label')}
                        {...fieldProps}
                        // minDate={validateDateFrom()}
                        // maxDate={validateDateTo()}
                        firstDayOfWeek={DayOfWeek.Monday}
                        strings={DayPickerStrings}
                        disabled={true}
                        showWeekNumbers={true}
                        formatDate={onFormatDate as any}
                        initialPickerDate={new Date(proving.dateFrom)}
                      />
                    )}
                  />
                  <FieldStackItem
                    name={`trackHotels.return.${i}.dateTo`}
                    render={(fieldProps) => (
                      <FormikGraphQLDatePicker
                        label={t('field.trackHotel.dateTo.label')}
                        {...fieldProps}
                        // minDate={validateDateFrom()}
                        // maxDate={validateDateTo()}
                        firstDayOfWeek={DayOfWeek.Monday}
                        strings={DayPickerStrings}
                        disabled={true}
                        showWeekNumbers={true}
                        formatDate={onFormatDate as any}
                        initialPickerDate={new Date(proving.dateFrom)}
                      />
                    )}
                  />
                  <FieldStack>
                    <FieldStackItem
                      name={`trackHotels.return.${i}.bookingStatus`}
                      render={(fieldProps: FieldProps<any>) => (
                        <FormikDropdown
                          label={t('field.bookingStatus.label')}
                          {...fieldProps}
                          options={statusOptions}
                        />
                      )}
                    />
                  </FieldStack>
                </FieldStack>
              ))}
            </AutoStack>
          )
        }}
      </FieldArray>
    </FormStack>
  )
}
